import { debounce } from '@opten/reactive/debounce';
import { Component } from '@opten/compiler/metadata/component';
import { toggleClass } from '@opten/dom/toggle-class';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-navbar' })
export class NavbarComponent {
	private toggler: HTMLElement[];
	private subItems: HTMLElement[];
	private subItemsToggler: HTMLElement[];

	private modalOffset = 50;
	private maxMobile = 767;

	constructor(private element: HTMLElement) {
		this.toggler = Array.from(
			element.getElementsByClassName('js-navbar-toggler')
		) as HTMLElement[];
		this.subItems = Array.from(
			element.getElementsByClassName('js-navbar-sub-item')
		) as HTMLElement[];
		this.subItemsToggler = Array.from(
			element.getElementsByClassName('js-navbar-sub-item-toggler')
		) as HTMLElement[];

		this.toggler.forEach((toggler) => {
			toggler.addEventListener('click', (e) => {
				e.preventDefault();
				window.scrollTo(0, 0);
				toggleClass(document.body, 'is-open');
			});
		});

		this.subItems.forEach((subItem) => {
			subItem.addEventListener('click', (e) => {
				e.preventDefault();
				const isOpen = hasClass(subItem, 'is-open');
				const modal = subItem.nextElementSibling as HTMLElement;
				const left = e.pageX;
				const top = e.pageY - window.scrollY;
				this.setModalPos(left, top, modal);
				this.subItems.filter((o) => removeClass(o, 'is-open'));
				toggleClass(subItem, 'is-open', !isOpen);
				window.addEventListener(
					'resize',
					debounce(() => {
						const rect = subItem.getBoundingClientRect();
						this.setModalPos(
							rect.left + rect.width / 2,
							rect.top + rect.height / 2,
							modal
						);
					}, 200)
				);
			});
		});

		this.subItemsToggler.forEach((toggler) => {
			toggler.addEventListener('click', (e) => {
				e.preventDefault();
				this.subItems.filter((o) => removeClass(o, 'is-open'));
			});
		});

		document.addEventListener('click', (e) => {
			if (
				hasClass(document.body, 'is-open') &&
				!e.target.closest('header')
			) {
				e.preventDefault();
				toggleClass(document.body, 'is-open');
			}
		});

		window.addEventListener(
			'resize',
			debounce(() => {
				this.setNavSize();
			}, 300)
		);

		this.setNavSize();
	}

	private setNavSize() {
		document.documentElement.style.setProperty(
			'--navbar-height',
			this.element.offsetHeight + 'px'
		);
	}

	private setModalPos(left: number, top: number, modal: HTMLElement) {
		if (window.innerWidth > this.maxMobile) {
			modal.style.left =
				left + modal.clientWidth + this.modalOffset < window.innerWidth
					? left - this.modalOffset + 'px'
					: window.innerWidth +
					  0 -
					  this.modalOffset -
					  modal.clientWidth +
					  'px';
			modal.style.top =
				top + modal.clientHeight + this.modalOffset < window.innerHeight
					? top - this.modalOffset + 'px'
					: window.innerHeight +
					  0 -
					  this.modalOffset -
					  modal.clientHeight +
					  'px';
		} else {
			modal.removeAttribute('style');
		}
	}
}
